import duplicateSubOrderGroup from '../../../../../Services/duplicateSubOrderGroup'

export default (guid) => (dispatch) => {

  dispatch(duplicateSubOrderGroup(guid))

}
